import { render, staticRenderFns } from "./DashboardAdministrativo.vue?vue&type=template&id=993bea5c"
import script from "./DashboardAdministrativo.vue?vue&type=script&lang=js"
export * from "./DashboardAdministrativo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports